import { useMemo, useEffect } from 'react';
import VirtualizedTable from '../../components/common/VirtualizedTable';
import {Box, Typography, Paper } from "@mui/material";

const SummaryCriteriaAnalyticsTable = ({ data, onCriteriaDataReceived, tableName = 'Средний балл по критериям', skillType = 'soft' }) => {
  // Определение колонок для таблицы критериев
  const criteriaColumns = useMemo(() => [
    {
      accessorKey: 'criteria_name',
      header: 'Критерий',
      size: 300,
      enableSorting: true,
    },
    {
      accessorKey: 'avg_score_percent',
      header: 'Средний балл (%)',
      size: 150,
      enableSorting: true,
    },
  ], []);

  // Агрегация данных по критериям
  const criteriaData = useMemo(() => {
    if (!data.length) return [];

    // Сбор общей статистики по критериям
    const criteriaStats = {};
    data.forEach(item => {
      item.assessment.items.forEach(criteriaItem => {
        // Фильтруем по type_skills
        if (criteriaItem.type_skills !== skillType) return;

        const { criteria_name, score, positive } = criteriaItem;

        if (!criteriaStats[criteria_name]) {
          criteriaStats[criteria_name] = { total_score: 0, count: 0 };
        }
        if (!positive){
          criteriaStats[criteria_name].total_score += 1-score;
        }else {
          criteriaStats[criteria_name].total_score += score;
        }
        criteriaStats[criteria_name].count += 1;
      });
    });
    // Преобразование в массив и расчет среднего балла в процентах
    return Object.keys(criteriaStats).map(name => ({
      id: name,
      criteria_name: name,
      avg_score_percent: ((criteriaStats[name].total_score / criteriaStats[name].count) * 100).toFixed(2)
    })).sort((a, b) => b.avg_score_percent - a.avg_score_percent); // Сортировка по убыванию
  }, [data, skillType]);

  // Уведомление родительского компонента о полученных данных по критериям
  useEffect(() => {
    if (onCriteriaDataReceived) {
      onCriteriaDataReceived({ criteriaData, criteriaColumns });
    }
  }, [criteriaData, criteriaColumns, onCriteriaDataReceived, skillType]);

  return (
    <>
      {criteriaData.length > 0 && (
        <Box sx={{ height: '100%', width: '100%', mt: 4 }}>
          <Paper sx={{ p: 2, height: '100%', width: '100%' }}>
            <Typography variant="h6" gutterBottom>
              {tableName}
            </Typography>
            <VirtualizedTable 
              data={criteriaData} 
              columns={criteriaColumns}
              noDataText="Нет данных для отображения"
              tableName={tableName}
              pageSize={10}
              frozenColumnCount={0}
            />
          </Paper>
        </Box>
      )}
    </>
  );
};

export default SummaryCriteriaAnalyticsTable;
